import { createSlice } from '@reduxjs/toolkit';

const pubLoginSlice = createSlice({
  name: "pubLogin",
  initialState: {
    isLoggedIn: false,
    userPhone: null, // Change the initial state of userPhone to null
  },
  reducers: {
    loginSuccess(state, action) {
      state.isLoggedIn = true;
      state.userPhone = action.payload; // Update userPhone with the payload
    },
    logout(state) {
      state.isLoggedIn = false;
      state.userPhone = null;
    }
  }
});

export const { loginSuccess, logout } = pubLoginSlice.actions;
export default pubLoginSlice.reducer;
